import { useState } from "react";
import { startCheckout } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, ArrowUpRight } from "lucide-react";

export default function PayButton({
  packageId,
  path,
  children,
  className = "",
  variant = "solid",
  testId,
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);
      toast.loading("Opening secure checkout…", { id: "pay" });
      await startCheckout(packageId, { path });
    } catch (e) {
      toast.error("Could not start checkout. Please try again.", { id: "pay" });
      setLoading(false);
    }
  };

  const base =
    "group inline-flex items-center justify-center gap-2 rounded-full px-8 py-4 text-sm uppercase tracking-[0.18em] font-medium transition-all duration-300 disabled:opacity-60";
  const styles =
    variant === "solid"
      ? "bg-primary text-primary-foreground hover:-translate-y-1 hover:shadow-[0_20px_40px_-15px_rgba(193,119,103,0.6)]"
      : "border border-foreground/25 text-foreground hover:border-primary hover:text-primary hover:-translate-y-1";

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={handleClick}
      disabled={loading}
      className={`${base} ${styles} ${className}`}
    >
      {loading ? (
        <Loader2 className="h-4 w-4 animate-spin" strokeWidth={1.5} />
      ) : (
        <>
          {children}
          <ArrowUpRight
            className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
            strokeWidth={1.5}
          />
        </>
      )}
    </button>
  );
}
